/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/*
alert("ok");
    $('body').on('keypress', '[name="q"], [type="search"],.Search__Input', function() {
alert(e.keyCode);
        if (e.keyCode == 13) {
            alert("Enter pressed");
            return false; // prevent the button click from happening
        }      
      
    });


$(document).on('keypress', '.Search__Form .Search__Input', function(e) {
        if (e.keyCode == 13) {
            alert("Enter pressed");
            return false; // prevent the button click from happening
        }
});
*/


$(".Search__Form .Search__Input").focusout(function(){
    //$(this).css("background-color", "#FFFFFF");
  	//alert("ok");
  $(".Search__Close").trigger("click");
});


 //setTimeout(function(){ document.getElementsByClassName('ProductForm__Item_color')[0].style.visibility = 'visible';}, 3000);